var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1042_11146)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#00748F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.229 177.408V358.338C460.229 379.372 443.178 396.423 422.144 396.423H248.746L179.414 447.822C175.307 450.867 169.483 447.935 169.483 442.822V396.423H150.546C129.513 396.423 112.461 379.372 112.461 358.338V177.408C112.461 156.375 129.513 139.324 161.07 139.324H432.668C443.178 139.324 460.229 156.375 460.229 177.408Z",
    fill: "url(#paint0_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.293 164.494H303.705C299.915 164.494 296.841 161.419 296.841 157.629C296.841 153.839 299.915 150.765 303.705 150.765H310.293C314.082 150.765 317.157 153.839 317.157 157.629C317.157 161.419 314.082 164.494 310.293 164.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.964 164.493H339.306C335.516 164.493 332.442 161.418 332.442 157.629C332.442 153.839 335.516 150.764 339.306 150.764H401.964C405.754 150.764 408.829 153.839 408.829 157.629C408.829 161.418 405.754 164.493 401.964 164.493Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.247 334.838C127.457 334.838 124.383 331.763 124.383 327.973V285.828C124.383 282.038 127.457 278.963 131.247 278.963C135.037 278.963 138.112 282.038 138.112 285.828V327.973C138.112 331.763 135.037 334.838 131.247 334.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.247 265.664C127.457 265.664 124.383 262.589 124.383 258.799V251.658C124.383 247.868 127.457 244.793 131.247 244.793C135.037 244.793 138.112 247.868 138.112 251.658V258.799C138.112 262.589 135.037 265.664 131.247 265.664Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M460.229 177.399V358.348C460.229 379.376 443.183 396.422 422.155 396.422H248.746L179.459 447.862C175.341 450.882 169.483 447.953 169.483 442.827V430.38L229.86 385.576C231.901 384.061 234.376 383.243 236.918 383.243H406.411C427.44 383.243 444.487 366.196 444.487 345.167V164.219C444.487 156.255 442.015 148.842 437.805 142.709C451.076 148.659 460.229 161.931 460.229 177.399Z",
    fill: "#1C2634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.07 336.718V199.026C149.07 186.273 159.409 175.934 182.686 175.934H402.448C412.836 176.255 423.622 186.273 423.622 199.026V336.718C423.622 349.472 413.284 359.811 400.53 359.811H172.162C159.409 359.811 149.07 349.472 149.07 336.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.617 199.046V336.703C423.617 349.516 413.275 359.768 400.552 359.768H172.136C161.794 359.768 153.099 353.086 150.078 343.659C151.451 343.934 152.916 344.024 154.38 344.024H382.704C395.427 344.024 405.769 333.682 405.769 320.869V183.212C405.769 180.832 405.403 178.452 404.763 176.255C415.471 178.269 423.617 187.696 423.617 199.046Z",
    fill: "#C7F5FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.481 263.254C242.44 263.254 242.388 263.254 242.347 263.254C240.312 263.182 238.73 261.476 238.802 259.441C239.336 244.755 246.438 231.364 258.257 222.7C259.891 221.487 262.203 221.837 263.405 223.491C264.608 225.136 264.248 227.438 262.614 228.64C252.614 235.968 246.623 247.293 246.16 259.708C246.088 261.692 244.454 263.254 242.481 263.254Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.436 218.959C273.015 216.975 274.289 215.022 276.283 214.591C279.181 213.974 282.172 213.625 285.173 213.553C287.136 213.964 288.893 215.105 288.944 217.14C288.996 219.174 287.393 220.86 285.358 220.911C282.819 220.983 280.27 221.281 277.804 221.805C275.802 222.206 273.86 220.948 273.436 218.959Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.027 73.936L255.139 130.89C258.214 138.154 256.041 146.488 249.867 151.398C235.86 162.537 214.538 183.378 204.101 198.643C199.424 205.483 191.039 209.029 182.872 207.621C164.672 204.483 134.925 205.269 117.2 207.564C109.379 208.576 101.885 204.336 98.8109 197.074L74.6986 140.117L231.027 73.936Z",
    fill: "#474646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.025 73.9741L255.111 130.869C258.215 138.201 256.021 146.462 249.885 151.358C235.901 162.531 214.528 183.4 204.125 198.639C199.449 205.434 191.004 209.009 182.872 207.637C164.689 204.499 134.922 205.28 117.165 207.544C112.571 208.068 108.037 206.923 104.502 204.261C106.683 204.76 109.063 204.954 111.474 204.701C129.191 202.344 158.997 201.656 177.18 204.793C185.274 206.072 193.719 202.497 198.433 195.796C208.837 180.556 230.17 159.595 244.194 148.514C250.33 143.618 252.524 135.358 249.42 128.025L227.219 75.5852L231.025 73.9741Z",
    fill: "#2D2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.83 92.3296L241.242 98.0268L174.263 149.213C172.531 150.576 170.439 151.462 168.254 151.757L84.9272 164.202L82.5153 158.505L165.842 146.06C168.008 145.721 170.1 144.835 171.852 143.516L238.83 92.3296Z",
    fill: "#2D2C2C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.784 198.606C114.941 199.386 112.813 198.524 112.033 196.681L108.879 189.231C108.099 187.388 108.961 185.26 110.804 184.48C112.647 183.7 114.775 184.562 115.555 186.405L118.709 193.855C119.489 195.697 118.627 197.826 116.784 198.606Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.967 180.143C107.124 180.923 104.996 180.061 104.216 178.218L103.078 175.53C102.298 173.687 103.16 171.558 105.003 170.778C106.846 169.998 108.974 170.86 109.754 172.703L110.892 175.392C111.673 177.234 110.81 179.363 108.967 180.143Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.018 64.9512L263.565 70.9697L263.507 70.9944C263.885 72.2119 263.571 73.5856 262.409 74.4218L171.881 143.615C170.176 144.957 168.072 145.848 165.863 146.163L53.2877 162.953C51.6785 163.221 50.3994 162.315 49.8214 161.113C49.7968 161.055 49.7968 161.055 49.772 160.996L47.3973 155.387C47.9168 156.614 49.1958 157.519 50.8882 157.285L163.463 140.495C165.647 140.121 167.752 139.231 169.482 137.947L260.01 68.7539C261.298 67.7264 261.537 66.1783 261.018 64.9512Z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.003 68.759L169.496 137.918C167.733 139.265 165.656 140.144 163.461 140.472L50.8619 157.298C47.5368 157.795 45.7344 153.537 48.4059 151.496L138.866 82.3721C140.629 81.0252 142.704 80.1466 144.898 79.8182L257.546 62.9566C260.872 62.4589 262.675 66.7175 260.003 68.759Z",
    fill: "#474646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0403 197.862L48.0881 162.528C45.5919 156.628 48.3571 149.786 54.2573 147.281L154.4 104.888C155.51 104.425 156.754 104.946 157.224 106.031C157.687 107.123 157.174 108.392 156.081 108.855L55.9382 151.249C52.2233 152.82 50.4751 157.132 52.0552 160.847L67.0073 196.181C67.4696 197.273 66.9569 198.542 65.8643 199.005C64.8011 199.456 63.5248 198.981 63.0403 197.862Z",
    fill: "#FACC15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8156 236.188L88.041 228.895C90.2219 227.972 90.9573 225.246 89.5188 223.336L75.5738 205.149C76.1023 203.298 75.9713 201.254 75.18 199.385C73.2391 194.8 67.9178 192.644 63.3338 194.585C58.7939 196.507 56.6375 201.829 58.5783 206.413C59.3697 208.282 60.7465 209.799 62.4434 210.708L65.7953 233.379C66.1662 235.742 68.6347 237.111 70.8156 236.188Z",
    fill: "#FACC15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8156 236.188L74.3319 234.7C72.1511 235.623 69.682 234.254 69.3117 231.891L66.3124 211.608C66.1215 210.317 65.5325 209.093 64.5344 208.252C63.4939 207.376 62.6502 206.237 62.0947 204.925C60.4177 200.964 61.8085 196.439 65.2079 194.055C64.5539 194.121 63.9565 194.322 63.3338 194.586C58.7939 196.508 56.6375 201.829 58.5783 206.414C59.3697 208.283 60.7465 209.799 62.4434 210.708L65.7953 233.38C66.1662 235.742 68.6347 237.112 70.8156 236.188Z",
    fill: "#ECB021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.277 102.167C168.692 105.509 163.521 110.872 155.817 114.134C148.022 117.434 140.571 117.414 139.156 114.072C137.741 110.73 142.913 105.366 150.708 102.066C158.412 98.8042 165.862 98.8246 167.277 102.167Z",
    fill: "#FACC15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.888 325.438C293.138 325.438 296.583 321.993 296.583 317.743C296.583 313.493 293.138 310.048 288.888 310.048C284.638 310.048 281.193 313.493 281.193 317.743C281.193 321.993 284.638 325.438 288.888 325.438Z",
    fill: "url(#paint1_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.888 325.438C293.138 325.438 296.583 321.993 296.583 317.743C296.583 313.493 293.138 310.048 288.888 310.048C284.638 310.048 281.193 313.493 281.193 317.743C281.193 321.993 284.638 325.438 288.888 325.438Z",
    fill: "url(#paint2_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.888 325.438C293.138 325.438 296.583 321.993 296.583 317.743C296.583 313.493 293.138 310.048 288.888 310.048C284.638 310.048 281.193 313.493 281.193 317.743C281.193 321.993 284.638 325.438 288.888 325.438Z",
    fill: "url(#paint3_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.401 319.124H278.375C275.383 319.124 272.958 316.699 272.958 313.708V306.875H304.817V313.708C304.817 316.699 302.392 319.124 299.401 319.124Z",
    fill: "url(#paint4_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.401 319.124H278.375C275.383 319.124 272.958 316.699 272.958 313.708V306.875H304.817V313.708C304.817 316.699 302.392 319.124 299.401 319.124Z",
    fill: "url(#paint5_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.817 306.877V313.709C304.817 316.702 302.392 319.127 299.399 319.127H288.888V306.877H304.817Z",
    fill: "url(#paint6_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.925 249.345C320.925 231.5 306.335 217.063 288.433 217.312C271.133 217.553 257.033 231.706 256.855 249.007C256.776 256.721 259.423 263.814 263.893 269.382C268.637 275.292 271.945 282.223 273.822 289.566L274.058 290.486H303.721L304.029 289.282C305.916 281.901 309.439 275.069 314.134 269.069C318.389 263.632 320.925 256.785 320.925 249.345Z",
    fill: "url(#paint7_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.432 217.312C285.941 217.347 283.52 217.679 281.193 218.258V290.486H303.72L304.028 289.282C305.915 281.9 309.438 275.069 314.133 269.069C318.388 263.632 320.924 256.785 320.924 249.345C320.925 231.5 306.334 217.063 288.432 217.312Z",
    fill: "url(#paint8_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.888 263.732C302.35 263.732 313.262 253.805 313.262 241.558C313.262 229.312 302.35 219.384 288.888 219.384C275.427 219.384 264.514 229.312 264.514 241.558C264.514 253.805 275.427 263.732 288.888 263.732Z",
    fill: "url(#paint9_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.854 249.006C256.775 256.72 259.422 263.813 263.891 269.381C268.636 275.291 271.944 282.222 273.821 289.564L274.057 290.485H303.72L304.028 289.28C305.915 281.899 309.438 275.068 314.133 269.068C318.388 263.631 320.924 256.784 320.924 249.344C320.924 248.892 320.909 248.443 320.89 247.996H256.89C256.876 248.333 256.857 248.668 256.854 249.006Z",
    fill: "url(#paint10_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.475 311.192H270.301C267.792 311.192 265.757 309.158 265.757 306.648C265.757 304.139 267.792 302.104 270.301 302.104H307.475C309.984 302.104 312.019 304.139 312.019 306.648C312.019 309.158 309.984 311.192 307.475 311.192Z",
    fill: "url(#paint11_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.475 304.171H270.301C267.792 304.171 265.757 302.137 265.757 299.628C265.757 297.118 267.792 295.084 270.301 295.084H307.475C309.984 295.084 312.019 297.118 312.019 299.628C312.019 302.137 309.984 304.171 307.475 304.171Z",
    fill: "url(#paint12_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.475 297.149H270.301C267.792 297.149 265.757 295.115 265.757 292.605C265.757 290.096 267.792 288.062 270.301 288.062H307.475C309.985 288.062 312.019 290.096 312.019 292.605C312.019 295.115 309.985 297.149 307.475 297.149Z",
    fill: "url(#paint13_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.536 197.764C287.571 197.764 285.979 199.356 285.979 201.32V206.336C285.979 208.3 287.571 209.893 289.536 209.893C291.5 209.893 293.092 208.3 293.092 206.336V201.32C293.092 199.356 291.501 197.764 289.536 197.764Z",
    fill: "url(#paint14_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.299 215.995L337.191 211.35C337.932 209.53 337.058 207.455 335.238 206.714C333.419 205.973 331.344 206.847 330.602 208.666L328.711 213.312C327.97 215.131 328.844 217.206 330.663 217.948C332.483 218.689 334.558 217.815 335.299 215.995Z",
    fill: "url(#paint15_linear_1042_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.208 218.442C249.019 217.68 249.868 215.594 249.105 213.784L247.159 209.161C246.396 207.351 244.31 206.501 242.5 207.264C240.69 208.026 239.84 210.112 240.603 211.922L242.549 216.545C243.312 218.355 245.398 219.205 247.208 218.442Z",
    fill: "url(#paint16_linear_1042_11146)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1042_11146",
    x1: 112.461,
    y1: 139.324,
    x2: 610.752,
    y2: 300.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00748F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1042_11146",
    x1: 288.888,
    y1: 317.733,
    x2: 288.888,
    y2: 324.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0172FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1042_11146",
    x1: 283.714,
    y1: 317.743,
    x2: 297.115,
    y2: 317.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2740B0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2740B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1042_11146",
    x1: 281.193,
    y1: 310.048,
    x2: 303.686,
    y2: 316.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00748F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1042_11146",
    x1: 288.888,
    y1: 309.962,
    x2: 288.888,
    y2: 317.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0172FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1042_11146",
    x1: 272.958,
    y1: 306.875,
    x2: 305.236,
    y2: 331.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00748F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1042_11146",
    x1: 294.041,
    y1: 313.002,
    x2: 305.475,
    y2: 313.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#208DA4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1042_11146",
    x1: 273.994,
    y1: 244.134,
    x2: 306.967,
    y2: 269.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1042_11146",
    x1: 294.431,
    y1: 256.819,
    x2: 316.619,
    y2: 269.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    stopColor: "#BF1C27",
    stopOpacity: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B12529",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1042_11146",
    x1: 288.888,
    y1: 251.876,
    x2: 288.888,
    y2: 192.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1042_11146",
    x1: 288.888,
    y1: 271.665,
    x2: 288.888,
    y2: 289.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1042_11146",
    x1: 265.757,
    y1: 302.104,
    x2: 288.969,
    y2: 336.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00748F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1042_11146",
    x1: 265.757,
    y1: 295.084,
    x2: 288.969,
    y2: 329.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00748F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1042_11146",
    x1: 265.757,
    y1: 288.062,
    x2: 288.969,
    y2: 322.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00748F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1042_11146",
    x1: 279.464,
    y1: 201.923,
    x2: 302.861,
    y2: 206.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1042_11146",
    x1: 322.8,
    y1: 210.411,
    x2: 346.38,
    y2: 214.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1042_11146",
    x1: 232.48,
    y1: 210.512,
    x2: 261.225,
    y2: 215.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1042_11146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogo);
export default __webpack_public_path__ + "static/media/img_logo.c824eb2688fc80abcafc80794fda63ec.svg";
export { ForwardRef as ReactComponent };